module.exports = __webpack_public_path__ + "img/header_bg.e1db54d4.png";